export default __webpack_public_path__ + "static/media/Case-Estrategia-Conteudo-Social.9f3fa1ab.jpg";